var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-overlay",
        { attrs: { absolute: _vm.absolute, value: !_vm.existingPromo } },
        [
          _c(
            "v-row",
            { attrs: { align: "center" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mr-2",
                  attrs: { fab: "", "x-small": "", color: "white" }
                },
                [
                  _c("v-icon", { attrs: { color: "orange", "x-large": "" } }, [
                    _vm._v("mdi-alert-circle")
                  ])
                ],
                1
              ),
              _c("h3", [
                _vm._v("Save Promotion Details to Add Parties and Items")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-toolbar",
        { attrs: { flat: "", color: "#fff" } },
        [
          _c(
            "v-btn-toggle",
            {
              staticClass: "btnGroup",
              attrs: { dense: "", mandatory: "" },
              model: {
                value: _vm.addStores,
                callback: function($$v) {
                  _vm.addStores = $$v
                },
                expression: "addStores"
              }
            },
            [
              _c(
                "v-btn",
                {
                  staticStyle: { "border-right": "1px solid #9e9e9e" },
                  attrs: { height: "38", value: false }
                },
                [
                  _c("small", [
                    _vm._v(
                      _vm._s(
                        _vm.tenant === "alliance-retail-group"
                          ? "Selected"
                          : "All"
                      )
                    )
                  ]),
                  _c("v-icon", { staticClass: "ml-1", attrs: { small: "" } }, [
                    _vm._v("mdi-format-list-bulleted")
                  ])
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.id &&
                        (_vm.tenant === "alliance-retail-group" ||
                          !_vm.readOnlyPromo),
                      expression:
                        "id && (tenant === 'alliance-retail-group' || !readOnlyPromo)"
                    }
                  ],
                  staticStyle: {
                    "border-top-right-radius": "0px",
                    "border-bottom-right-radius": "0px"
                  },
                  attrs: { height: "38", value: true }
                },
                [
                  _c("small", [
                    _vm._v(
                      _vm._s(
                        _vm.tenant === "alliance-retail-group" ? "All" : "Add"
                      )
                    )
                  ]),
                  _c("v-icon", { staticClass: "ml-1", attrs: { small: "" } }, [
                    _vm._v("mdi-plus")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addStores,
                  expression: "addStores"
                }
              ],
              staticClass: "pl-0",
              staticStyle: { height: "64px" },
              attrs: { cols: "3" }
            },
            [
              _c("v-text-field", {
                staticStyle: {
                  "border-top-left-radius": "0px",
                  "border-bottom-left-radius": "0px"
                },
                attrs: {
                  label: "Search",
                  "append-icon": "mdi-window-close",
                  "background-color": "#fff",
                  outlined: "",
                  dense: ""
                },
                on: { "click:append": _vm.clearPartySearch },
                scopedSlots: _vm._u([
                  {
                    key: "prepend-inner",
                    fn: function() {
                      return [_c("v-icon", [_vm._v("mdi-magnify")])]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.addStores &&
                    _vm.$auth.tenant === "alliance-retail-group",
                  expression:
                    "addStores && $auth.tenant === 'alliance-retail-group'"
                }
              ],
              staticClass: "pl-0",
              staticStyle: { height: "64px" },
              attrs: { cols: "1" }
            },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Inclusion Filter",
                  items: _vm.inclusionFilterOptions,
                  clearable: "",
                  "hide-details": "auto",
                  "background-color": "#fff",
                  dense: "",
                  autocomplete: "off",
                  outlined: ""
                },
                model: {
                  value: _vm.storeInclusionFilter,
                  callback: function($$v) {
                    _vm.storeInclusionFilter = $$v
                  },
                  expression: "storeInclusionFilter"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.addStores,
                  expression: "!addStores"
                }
              ],
              staticClass: "pl-0",
              staticStyle: { height: "64px" },
              attrs: { cols: "3" }
            },
            [
              _c("v-text-field", {
                staticStyle: {
                  "border-top-left-radius": "0px",
                  "border-bottom-left-radius": "0px"
                },
                attrs: {
                  label: "Filter",
                  "append-icon": "mdi-window-close",
                  "background-color": "#fff",
                  outlined: "",
                  dense: ""
                },
                on: {
                  "click:append": function($event) {
                    _vm.filter = ""
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "prepend-inner",
                    fn: function() {
                      return [_c("v-icon", [_vm._v("mdi-filter-outline")])]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _vm.selectedStores.length > 0 && !_vm.addStores
            ? _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { color: "red" },
                  on: { click: _vm.handleRemoveClick }
                },
                [
                  _c("v-icon", { attrs: { left: "", dense: "", small: "" } }, [
                    _vm._v("mdi-trash-can-outline")
                  ]),
                  _vm._v(
                    " Remove Selected Groups (" +
                      _vm._s(_vm.selectedStores.length) +
                      ") "
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.tenant === "alliance-retail-group" &&
          _vm.id &&
          !_vm.editIsDisabled &&
          _vm.addStores
            ? _c(
                "v-btn",
                {
                  attrs: {
                    disabled: _vm.disableAddAllAdGroups,
                    inert: _vm.loading,
                    color: "success"
                  },
                  on: {
                    click: function($event) {
                      _vm.addAllAdGroupsModal = true
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "", dense: "", small: "" } }, [
                    _vm._v("mdi-plus")
                  ]),
                  _vm._v(" All Ad Groups ")
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("v-divider"),
      !_vm.addStores
        ? _c("v-data-table", {
            attrs: {
              height: _vm.tableSize,
              loading: _vm.loading,
              headers: _vm.headers,
              items: _vm.stores,
              search: _vm.filter,
              "items-per-page": _vm.storePageSize,
              "item-class": _vm.getRowClass,
              color: "#fff",
              "item-key": "id",
              "loading-text": "Loading...Please wait",
              "fixed-header": "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              "update:items": function($event) {
                _vm.stores = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "no-data",
                  fn: function() {
                    return [
                      _vm.stores.length < 1
                        ? _c("v-alert", {
                            staticClass: "mt-4",
                            attrs: { outlined: "", text: "", color: "orange" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mx-2 pb-1",
                                          attrs: { color: "orange" }
                                        },
                                        [_vm._v("mdi-alert-circle-outline")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          "Valid promotion requires at least one party added to promotion."
                                        )
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1020939415
                            )
                          })
                        : _vm._e()
                    ]
                  },
                  proxy: true
                },
                {
                  key: "item.name",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(item.store_num ? "#" : "") +
                            _vm._s(item.store_num) +
                            " " +
                            _vm._s(item.name) +
                            " "
                        )
                      ])
                    ]
                  }
                },
                {
                  key: "header.select",
                  fn: function() {
                    return [
                      _c("v-simple-checkbox", {
                        attrs: {
                          dark: "",
                          disabled: _vm.stores.length === 0,
                          dense: "",
                          ripple: false
                        },
                        model: {
                          value: _vm.includeAll,
                          callback: function($$v) {
                            _vm.includeAll = $$v
                          },
                          expression: "includeAll"
                        }
                      })
                    ]
                  },
                  proxy: true
                },
                {
                  key: "item.lump_sum",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm.showAllowanceField(item)
                        ? [
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "close-on-content-click": false,
                                  "close-on-click": false,
                                  bottom: "",
                                  right: "",
                                  absolute: "",
                                  "nudge-top": "-12px",
                                  "nudge-left": "16px",
                                  "offset-y": "",
                                  "max-width": "200px"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "div",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "edit-allowance-container",
                                                  style: !_vm.editIsDisabled
                                                    ? "cursor: pointer"
                                                    : "cursor: default",
                                                  on: {
                                                    click: function($event) {
                                                      !_vm.editIsDisabled
                                                        ? _vm.open(item)
                                                        : null
                                                    }
                                                  }
                                                },
                                                "div",
                                                attrs,
                                                false
                                              ),
                                              !_vm.editIsDisabled ? on : null
                                            ),
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    margin: "0 auto"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        display: "inline-block"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " $ " +
                                                          _vm._s(
                                                            item.lump_sum
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  !_vm.editIsDisabled
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "10px"
                                                          },
                                                          attrs: { small: "" }
                                                        },
                                                        [_vm._v(" mdi-pencil ")]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.editing,
                                  callback: function($$v) {
                                    _vm.editing = $$v
                                  },
                                  expression: "editing"
                                }
                              },
                              [
                                _vm.editItem &&
                                _vm.editItem.store_id === item.store_id
                                  ? _c(
                                      "v-card",
                                      {
                                        staticClass: "pt-2 px-4",
                                        attrs: { tile: "", flat: "" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: { "margin-top": "8px" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "subtitle-2" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.tenant ===
                                                      "pricechopper"
                                                      ? "Edit Ad Fee"
                                                      : "Edit Lump Sum"
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c("v-text-field", {
                                          ref: "allowance",
                                          staticClass: "pt-0 mt-0",
                                          attrs: {
                                            rules: [
                                              function(v) {
                                                return (
                                                  Boolean(v) ||
                                                  "Please enter a value"
                                                )
                                              },
                                              _vm.isValidAllowancePrice
                                            ],
                                            autofocus: "",
                                            type: "number",
                                            "hide-spin-buttons": "",
                                            prefix: "$"
                                          },
                                          model: {
                                            value: _vm.editItem.lump_sum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.editItem,
                                                "lump_sum",
                                                $$v
                                              )
                                            },
                                            expression: "editItem.lump_sum"
                                          }
                                        }),
                                        _c(
                                          "v-card-actions",
                                          { staticClass: "pt-0 px-0" },
                                          [
                                            _c("v-spacer"),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { text: "", small: "" },
                                                on: { click: _vm.cancel }
                                              },
                                              [_vm._v(" Cancel ")]
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  text: "",
                                                  small: "",
                                                  color: "primary",
                                                  loading: _vm.savingItem
                                                },
                                                on: { click: _vm.save }
                                              },
                                              [_vm._v(" Save ")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "item.view",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      item &&
                      item.party_type_name &&
                      item.party_type_name.toLowerCase() !== "store"
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                icon: "",
                                                small: "",
                                                color: "#1976d2"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.viewParties(item)
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-view-list")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v("View / Exclude")])]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "item.include_store",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-icon",
                        {
                          attrs: { color: item.include_store ? "green" : "red" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.include_store
                                  ? "mdi-checkbox-marked-circle-outline"
                                  : " mdi-close-circle-outline"
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "item.select",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("v-simple-checkbox", {
                        attrs: { color: "primary", dense: "", ripple: false },
                        on: {
                          input: function($event) {
                            return _vm.itemSelected($event, item)
                          }
                        },
                        model: {
                          value: item.selected,
                          callback: function($$v) {
                            _vm.$set(item, "selected", $$v)
                          },
                          expression: "item.selected"
                        }
                      })
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        : _c("v-data-table", {
            attrs: {
              id: "partiesList",
              height: _vm.tableSize,
              headers: _vm.headers,
              items: _vm.filteredParties,
              loading: _vm.loading,
              "loading-text": "Loading...Please wait",
              "items-per-page": _vm.storePageSize,
              "item-key": "party_id",
              "fixed-header": "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              "update:items": function($event) {
                _vm.filteredParties = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.view",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      item.party_type.toLowerCase() !== "store"
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                icon: "",
                                                small: "",
                                                color: "#1976d2"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.viewParties(item)
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-view-list")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v("View")])]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "item.actions",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _vm.editIsDisabled
                                      ? _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: item.disabled
                                                ? "green"
                                                : "red"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.disabled
                                                    ? "mdi-checkbox-marked-circle-outline"
                                                    : " mdi-close-circle-outline"
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                disabled: item.disabled,
                                                id:
                                                  _vm.$auth.tenant ===
                                                  "alliance-retail-group"
                                                    ? "arg-disabled-button"
                                                    : "",
                                                color:
                                                  _vm.$auth.tenant ===
                                                  "alliance-retail-group"
                                                    ? "grey"
                                                    : "green",
                                                icon: "",
                                                small: "",
                                                inert:
                                                  _vm.loading && !item.loading,
                                                loading: item.loading
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.add(item)
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-plus-circle")
                                            ])
                                          ],
                                          1
                                        )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_c("span", [_vm._v("Add")])]
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          }),
      _vm.viewPartiesModal
        ? _c("ViewParties", {
            attrs: {
              addStores: _vm.addStores,
              promo: _vm.promo,
              stores: _vm.stores,
              promoAllowances: _vm.promoAllowances,
              party: _vm.selectedParty,
              readOnlyPromo: _vm.editIsDisabled,
              downstreamPartyIds: _vm.downstreamPartyIds
            },
            on: {
              initStores: _vm.initPromoStoreList,
              close: _vm.closeViewParties,
              addParty: _vm.add,
              addGroupMembers: _vm.addGroupMembers,
              removeGroup: _vm.removeStoreConfirm
            },
            model: {
              value: _vm.viewPartiesModal,
              callback: function($$v) {
                _vm.viewPartiesModal = $$v
              },
              expression: "viewPartiesModal"
            }
          })
        : _vm._e(),
      _vm.removeDialog
        ? _c(
            "v-dialog",
            {
              attrs: { justify: "center", persistent: "", width: "500" },
              model: {
                value: _vm.removeDialog,
                callback: function($$v) {
                  _vm.removeDialog = $$v
                },
                expression: "removeDialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "ma-0 pa-6" },
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        "v-icon",
                        { attrs: { "x-large": "", color: "orange" } },
                        [_vm._v("mdi-alert-circle-outline")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "py-6", attrs: { justify: "center" } },
                    [
                      _vm.includeAll &&
                      _vm.selectedStores.length === _vm.stores.length
                        ? _c("h3", [_vm._v("Remove All Stores?")])
                        : _c("h3", [
                            _vm._v(
                              _vm._s(
                                "Remove Selected Groups/Stores" +
                                  (_vm.excludedStores.length > 0
                                    ? " and/or exclusions from " +
                                      _vm.excludedStores
                                        .map(function(s) {
                                          return s.name
                                        })
                                        .join(", ")
                                    : "") +
                                  "?"
                              )
                            )
                          ]),
                      _vm.isApprovedPromo && _vm.hasApprovedPromoStoreEditAccess
                        ? _c(
                            "div",
                            { staticStyle: { "margin-top": "25px" } },
                            [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    text: "",
                                    type: "error",
                                    border: "left"
                                  }
                                },
                                [
                                  _c("p", [
                                    _c("strong", [
                                      _vm._v(
                                        "Warning: Removing ad groups from approved promotions may impact existing ad planners and/or other downstream processes. Continue?"
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.lastPartySources.length > 0
                        ? _c(
                            "div",
                            { staticStyle: { "margin-top": "25px" } },
                            [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    text: "",
                                    type: "warning",
                                    border: "left"
                                  }
                                },
                                [
                                  _vm.lastPartySources.length > 1
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "Items with any of the following sources will also be removed from this promotion:"
                                          )
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.lastPartySources.join(", ")
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    : [
                                        _vm._v(" Any items with the source "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.lastPartySources[0])
                                          )
                                        ]),
                                        _vm._v(
                                          " will also be removed from this promotion. "
                                        )
                                      ]
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "v-row",
                    { staticClass: "pb-4 pt-2", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "elevation-3 white--text",
                                          attrs: {
                                            fab: "",
                                            small: "",
                                            color: "red"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.handleRemoveDialogClose(
                                                $event
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("mdi-close")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1566076342
                          )
                        },
                        [_c("span", [_vm._v("Cancel")])]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "white--text elevation-3 ml-2",
                                          attrs: {
                                            fab: "",
                                            small: "",
                                            color: "green"
                                          },
                                          on: { click: _vm.removeGroup }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("mdi-check")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2712618135
                          )
                        },
                        [_c("span", [_vm._v("Confirm")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.addAllAdGroupsModal
        ? _c(
            "v-dialog",
            {
              attrs: { justify: "center", persistent: "", width: "500" },
              on: {
                "click:outside": function($event) {
                  _vm.addAllAdGroupsModal = false
                }
              },
              model: {
                value: _vm.addAllAdGroupsModal,
                callback: function($$v) {
                  _vm.addAllAdGroupsModal = $$v
                },
                expression: "addAllAdGroupsModal"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "pl-6 pr-2 pt-4 pb-0" }, [
                    _c("div", { staticClass: "title h6" }, [
                      _vm._v(" Add All Ad Groups ")
                    ])
                  ]),
                  _c(
                    "v-container",
                    { staticClass: "pa-0", attrs: { fluid: "" } },
                    [
                      _c("div", { staticClass: "mx-6 mt-4 mb-6" }, [
                        _vm._v(
                          " Are you sure that you would like to add all available ad groups? "
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-center" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mb-4 mr-4",
                              attrs: { text: "" },
                              on: {
                                click: function($event) {
                                  _vm.addAllAdGroupsModal = false
                                }
                              }
                            },
                            [_vm._v(" Cancel ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mb-4",
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.addAllAdGroups()
                                }
                              }
                            },
                            [_vm._v(" Confirm ")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }